<template>
    <v-row dense>
        <v-col sm="6" cols="12" class="center vertical-whitespace">
            <v-form ref="searchTermsForm" style="width: 100%; height: 100%;" v-model="searchTagValidator" lazy-validation>
                <div style="display: flex; justify-content: space-between;">
                    <v-text-field outlined @keydown.enter.prevent="addSearchString"
                        color="#00006d" :label="label" class="col-8" v-model="searchTagString"></v-text-field>
                    <v-btn text color="green accent-3" style="min-height: 55px; border-radius: 10px;" class="col-3 ml-4"
                        @click.stop="addSearchString">
                        <v-icon>fas fa-plus-circle</v-icon>
                    </v-btn>
                </div>
            </v-form>
        </v-col>
        <v-col sm="6" cols="12" class="center vertical-whitespace">
            <v-container>
                <v-row>
                    <v-col>
                        <span v-if="searchTagLength > 0">(Click chip to delete term)</span>
                    </v-col>
                </v-row>
                <v-row>
                    <v-chip @click="deleteSearchString(index)" :ripple="false" class="search-chip center mx-3 my-3"
                        v-for="(tag, index) in businessSearchTags" :key="index">
                        <v-icon style="margin: 5px;">fas fa-search-location</v-icon>
                        <span style="margin: 5px;">{{ tag }}</span>
                    </v-chip>
                </v-row>
            </v-container>
        </v-col>
    </v-row>
</template>

<script>

export default {
    props: {
        businessSearchTags: {
            type: Array,
            default: () => []
        },
        label: {
            type: String,
            default: 'Custom Terms'
        }
    },
    data: () => ({
        searchTagValidator: false,
        searchTagString: ''
    }),
    methods: {
        deleteSearchString(index) { 
            this.$emit('delete-tag', index);
        },
        addSearchString() {
            if (this.$refs.searchTermsForm.validate() && this.searchTagString !== '') {
                this.$emit('add-tag', this.searchTagString);
                this.searchTagString = '';
                this.$refs.searchTermsForm.resetValidation()
            }
            setTimeout(() => {
                this.$refs.searchTermsForm.resetValidation()
            }, 1000);
        }
    },
    computed: {
        // searchTagStringRules() {
        //     return [v => v.indexOf(' ') === -1 || 'Single Words Only']
        // },
        searchTagLength() {
            return this.businessSearchTags.length;
        }
    }
}
</script>
